import { makeMap } from '@/utils/utils';

const fcbrTableProps = [
  { item: '烟雾', mod: 'Smoke', bgVal: 'smokeBground', realVal: 'smokeData' },
  { item: '云端总荧光值', mod: 'BIO', bgVal: 'bioEffectiveBground', realVal: 'bioEffective' },
  {
    item: '设备总荧光值',
    mod: 'BIO',
    bgVal: 'bioBground',
    realVal: v => v.bioBground + v.bioConcentration
  },
  { item: '大颗粒比', mod: 'BIO', bgVal: '-', realVal: 'bioParRatioLarge' },
  { item: '小颗粒比', mod: 'BIO', bgVal: '-', realVal: 'bioParRatioSmall' },
  { item: 'PID', mod: 'TVOC', bgVal: 'pidBground', realVal: 'pidValue' },
  { item: 'NH3', mod: 'TVOC', bgVal: 'nh3Bground', realVal: 'nh3' },
  { item: 'CL2', mod: 'TVOC', bgVal: 'cl2Bground', realVal: 'cl2' },
  { item: 'CO', mod: 'TVOC', bgVal: 'coBground', realVal: 'co' },
  { item: 'GasName', mod: 'CWA', bgVal: '-', realVal: 'gasName' },
  { item: 'Concentration', mod: 'CWA', bgVal: '-', realVal: 'concentration' },
  { item: 'Scell', mod: 'CWA', bgVal: 'sccellBground', realVal: 'sccellData' },
  { item: 'ScellR', mod: 'CWA', bgVal: 'sccellRBground', realVal: 'sccellRData' },
  { item: 'γ值', mod: 'NUCLEAR', bgVal: 'radDoseBground', realVal: 'radDose' },
  { item: 'αβ值', mod: 'NUCLEAR', bgVal: 'radBetaBground', realVal: 'radBeta' },
  { item: 'γ值2', mod: 'NUCLEAR', bgVal: 'radDose2Bground', realVal: 'radDose2' },
  { item: 'αβ值2', mod: 'NUCLEAR', bgVal: 'radBeta2Bground', realVal: 'radBeta2' }
];

const bmTableProps = [
  { item: '云端总荧光值', mod: 'BIO', bgVal: 'bioEffectiveBground', realVal: 'bioEffective' },
  {
    item: '设备总荧光值',
    mod: 'BIO',
    bgVal: 'bioBground',
    realVal: v => v.bioBground + v.bioConcentration
  },
  { item: '大颗粒比', mod: 'BIO', bgVal: '-', realVal: 'bioParRatioLarge' },
  { item: '小颗粒比', mod: 'BIO', bgVal: '-', realVal: 'bioParRatioSmall' }
];

/**
 * 设备类型对应选项
 */
const deviceOptions = [
  { reg: /^fcbr.*/i, cfg: fcbrTableProps },
  { reg: /^bm.*/i, cfg: bmTableProps }
];

/**
 * 对应设备配置
 */
// const deviceConfig = {
//   'FCBR-100': { has: 'Smoke,BIO,TVOC,CWA' },
//   'FCBR-100B': { has: 'BIO' },
//   'FCBR-100F': { has: 'Smoke,BIO,TVOC,CWA' },
//   'FCBR-100PRO': { has: 'Smoke,BIO,TVOC,CWA,NUCLEAR' },
//   'FCBR-100CP': { has: 'Smoke,TVOC,CWA' }
// };

/**
 * 根据设备类型 返回所拥有mod配置
 * @param {'deviceType'} t 设备类型
 * @returns {typeof fcbrTableProps} 表格所需配置
 */
export const getTableOption = (t, mods) => {
  const option = deviceOptions.find(e => e.reg.test(t));
  if (!option) return false;
  const has = makeMap(mods.join(','));
  const demand = option.cfg.filter(e => has(e.mod.toLowerCase() + 'Mod'));
  return demand;
};
